import tw, { css } from 'twin.macro'

const baseStyle = css`
  ${tw`flex justify-between items-center relative h-[475px] mb-18 lg:h-[650px]`}

  .button-disabled {
    opacity: 0.2;

    &:hover {
      background-color: transparent;
    }
  }
`

export const getNavigationButtonStyle = (color: string) => css`
  & {
    border-color: ${color};
    &:hover {
      background-color: ${color};
    }
  }
`

export default baseStyle
